module.exports = __webpack_public_path__ + "static/media/export.f2b42a0d.jpeg";